import { OfferCard } from "@/components/OfferCard";
import { SectionGroup } from "@/utils/groupBySections";
import { memo } from "react";

interface OfferSectionProps {
  section: SectionGroup;
  isDarkMode: boolean;
}

export const OfferSection = memo(function OfferSection({ section, isDarkMode }: OfferSectionProps) {
  return (
    <section className="mb-10">
      <h2 className={`text-2xl font-bold mb-6 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
        {section.sectionName}
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {section.offers.map((offer) => (
          <OfferCard key={`${section.sectionName}-${offer.id}`} offer={offer} />
        ))}
      </div>
    </section>
  );
});